import React, { useState, useEffect, createContext } from 'react'
import NavBar from './navBar/NavBar';
import Dashboard from './dashboard/Dashboard';
import { useTranslation } from "react-i18next"; // 1.1 i18n
import Residents from './residents/Residents';
import Pad from './pad/Pad';
import User from './user/User';
// import Bed from './beds/Two_Beds';
import AddPageFrame from './add/AddPageFrame';
import { ADD_RESIDENTS_ARRAY } from '../stores/reducer_residentsArray';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../actions/ApiGo';
import { ADD_USERS_ARRAY } from '../stores/reducer_usersArray';
import { ADD_ALL_MAC_ALERTS_SETTING_ARRAY } from '../stores/reducer_padsArray';
import { ADD_BEDS_ARRAY } from '../stores/reducer_beds';
import AddPopUp from './popUp/AddPopUp';
import PrintPage from './residents/Print/PrintPage';
import Mos from '../actions/Mos';
import EPDeviceControl from './epmed/EPDeviceControl';
import ConfigHandler from '../actions/ConfigHandler';
import { SET_LAYOUT_STATE } from '../stores/reducer_LayoutPage';
import DashboardEP from './dashboard/DashboardEP';
import { BedsteadManagement } from './epmed/BedsteadManagement';
import { ADD_BEDSTEADS_ARRAY } from '../stores/reducer_bedsteadsArray';
import DashboardSorting from './card/EP/Assign/DashboardSorting';
import { ADD_DEVICE_ARRAY } from '../stores/reducer_Device';
import DownloadHis from './residents/Print/DownloadHis';
import Dropdown from './dropdown/Dropdown';
import comm_imgs from '../comm_imgs';
import comm_data from '../comm_data';
import { loginStore } from '../comm_stores';
import ICON_QUICK_START_SIMPLE from '../assets/images/ICON_QUICK_START_SIMPLE.png';
import ICON_QUICK_START_DETAIL from '../assets/images/ICON_QUICK_START_DETAIL.png';
import ICON_QUICK_START_VIDEO from '../assets/images/ICON_QUICK_START_VIDEO.png';

const date = new Date();
const year = date.getFullYear()
const markC = "©"

export const CTXHide = createContext()

const InfoMenu = ({ showInfoMenu, setShowInfoMenu, t, i18n }) => {
    const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    const menuItems = [
        { label: t("GLOBAL.QUICK_START_SIMPLE"), icon: ICON_QUICK_START_SIMPLE, path: `${comm_data.API_HOST}/static/quickops.pdf` },
        { label: t("GLOBAL.QUICK_START_DETAIL"), icon: ICON_QUICK_START_DETAIL, path: `${comm_data.API_HOST}/static/quickstart.pdf` },
        //{ label: t("GLOBAL.QUICK_START_VIDEO"),  icon: ICON_QUICK_START_VIDEO  },
    ];
    return (
        <div
            id="infoMenuWrapper"
            style={{ position: 'relative', minWidth: '52px' }}
            onMouseEnter={() => { if (!isTouchDevice) setShowInfoMenu(true); }}
            onMouseLeave={() => { if (!isTouchDevice) setShowInfoMenu(false); }}
        >
            <div
                className='tag download font-ml fx-ccc'
                style={{ width: '35px' }}
                onClick={(e) => { e.stopPropagation(); setShowInfoMenu(prev => !prev); }}
            >
                <div className='fx-d-r fx-ccc delayShow'>
                    <div className='fx-ccc w-20'><img src={comm_imgs.DB_INFO} /></div>
                </div>
            </div>
            <div style={{
                position: 'absolute', top: '0%', right: 0, zIndex: 999,
                minWidth: '180px', borderRadius: '12px', overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                visibility: showInfoMenu ? 'visible' : 'hidden',
                pointerEvents: showInfoMenu ? 'auto' : 'none',
            }}>
                {menuItems.map((item, index) => (
                    <button
                        key={index}
                        className="font-ml"
                        style={{
                            whiteSpace: 'nowrap', padding: '14px 18px', cursor: 'pointer',  // ✅ padding 加大
                            background: '#e8f0fe', minHeight: '52px', border: 'none',       // ✅ minHeight 加高

                            width: '100%', font: 'inherit', color: 'inherit',
                            textAlign: 'left',                       // ✅ 確保文字靠左
                            display: 'block',
                        }}
                        onClick={(e) => { e.stopPropagation(); setShowInfoMenu(false); window.open(item.path, '_blank', 'noopener,noreferrer'); }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}> {/* ✅ gap 加大 */}
                            <img src={item.icon} style={{
                                width: '30px', height: '30px',
                                objectFit: 'contain',
                                mixBlendMode: 'multiply',
                            }} />
                            <span style={{ fontSize: '1.05em', fontWeight: 'bold' }}>{item.label}</span>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

const Layout = () => {

    const { t, i18n } = useTranslation(); // 1.2 i18n
    const [returnSearchResults, setReturnSearchResults] = useState("");
    const mos = Mos()
    const exportStart = mos.exportStart;
    const [residentExport, setResidentExport] = useState([]);
    const LayoutPage = useSelector(state => state.store_layout)
    //讀取 localStorage 初始值
    const [sortDesc, setSortDesc] = useState(() => {
        return localStorage.getItem("cardSortDesc") === "true"
    });

    function toggleSortDesc() {
        setSortDesc(prev => {
            const next = !prev;
            localStorage.setItem("cardSortDesc", String(next));
            return next;
        });
    }
    // i18n
    // account role base
    let currentAccount = localStorage.getItem("currentAccount")
    // const accountRole = currentAccount!==null? JSON.parse(localStorage.getItem(currentAccount)).role:null
    let currentInstitution = localStorage.getItem("currentInstitution")
    const [addPage, setAddPage] = useState(false);
    function toggleAddPage() {
        if (addPage) {
            setRefresh(true)
        }
        setAddPage(!addPage)
    }
    const [sortPage, setSortPage] = useState(false);
    function toggleSortPage() { setSortPage(!sortPage) }
    const [leave, setLeave] = useState(false);
    function toggleLeave() { setLeave(!leave) }
    const [downloadHis, setDownloadHis] = useState(false);
    const [refresh, setRefresh] = useState(true);
    function toggleDownloadHis() { setDownloadHis(!downloadHis) }

    // dropdown data
    const store_institution = useSelector(state => state.store_beds.institutions)
    // dropdown 組合
    const [dropdown_open, setDropdown_open] = useState(false);
    function toggleDropdown() { setDropdown_open(!dropdown_open) }
    const DP_data = { id: "", keys: store_institution }
    function toggleDropdown() { setDropdown_open(!dropdown_open) }
    // const [returnInst, setReturnInst] = useState(t("GLOBAL.BED_STATE.ALL"));     //dropdown return result
    // 教學文檔下載
    const [returnInst, setReturnInst] = useState("全部單位");     //dropdown return result

    const [downloadIntro, setDownloadIntro] = useState(false);
    const [voiceBtn, setVoiceBtn] = useState(false);
    const [showInfoMenu, setShowInfoMenu] = useState(false);
    const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    /*
    const openQuickStart = () => {
        window.open(`${comm_data.API_HOST}/static/quickstart.pdf`, '_blank', 'noopener,noreferrer');
    };
    */

    useEffect(() => {
        if (document.visibilityState === 'hidden') setShowInfoMenu(false);
        document.addEventListener('visibilitychange', () => setShowInfoMenu(false));
        return () => document.removeEventListener('visibilitychange', () => setShowInfoMenu(false));
    }, []);

    useEffect(() => {
        if (!showInfoMenu) return;
        function handleClickOutside(e) {
            const wrapper = document.getElementById('infoMenuWrapper');
            if (wrapper && !wrapper.contains(e.target)) setShowInfoMenu(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [showInfoMenu]);
    // useEffect(() => {
    //     setReturnInst(t("GLOBAL.BED_STATE.ALL"));
    // }, [i18n.language, t]);
    // ------------------ redux ------------------
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(SET_LAYOUT_STATE(ConfigHandler.layoutControl().pageNum))
    }, [dispatch]);

    useEffect(() => {
        if (!refresh) {
            setRefresh(false)
            return
        }
        const initStatus = ConfigHandler.initStatus();
        ApiGo.getResidents()
            .then(res => {
                dispatch(ADD_RESIDENTS_ARRAY(res))
                let res_with_pad = res.filter(r => r.mac_right)
                setResidentExport(res_with_pad)
            })
            .catch(err => { console.log(err); })

        ApiGo.getUsers()
            .then(res => {
                dispatch(ADD_USERS_ARRAY(res.users))
            })
            .catch(err => { console.log(err); })

        if (ConfigHandler.isShowEP()) {                                           // 奕寶
            ApiGo.getEpmedDevice()
                .then(res => { dispatch(ADD_DEVICE_ARRAY(res)) })
                .catch(err => { })
            ApiGo.getBedsteads()
                .then(res => { dispatch(ADD_BEDSTEADS_ARRAY(res)) })
                .catch(err => { console.log(err); })
        } else {                                                                  // 美維
            ApiGo.getBed()
                .then(res => { dispatch(ADD_BEDS_ARRAY(res.beds) || []) })
                .catch(err => { console.log(err); })
            // if(ConfigHandler.isShowAIDC()){                                     // aidc
            ApiGo.getAll_mac_alert_setting()
                .then(res => { dispatch(ADD_ALL_MAC_ALERTS_SETTING_ARRAY(res)) })
                .catch(err => { console.log(err); })
            // }
        }

        setRefresh(false)
    }, [dispatch, refresh]);
    // ------------------ redux ------------------
    function pageHandler() {
        let curCom = ConfigHandler.layoutControl().layoutArr[LayoutPage.currentPage][1]
        switch (curCom) {
            case 'NAV_BAR.FRONT_PAGE':
                let com = ConfigHandler.isShowEP() ? <DashboardEP mos={mos} /> : <Dashboard mos={mos} sortDesc={sortDesc} />
                return {
                    component: com,
                    addPageBtn: true,
                    addPageName: '床位排序',
                    i18nSearchResults: ''
                }
            case 'NAV_BAR.RESIDENTS':
                return {
                    component: <Residents setReturnData={setReturnSearchResults} leave={leave} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_RESIDENTS"),
                    i18nSearchResults: t("GLOBAL.SEARCH_RESULTS") + " " + returnSearchResults + " " + t("GLOBAL.PEOPLE")
                }
            case 'NAV_BAR.USERS':
                return {
                    component: <User setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_USERS"),
                    i18nSearchResults: t("GLOBAL.SEARCH_RESULTS") + " " + returnSearchResults + " " + t("GLOBAL.PEOPLE")
                }
            case 'NAV_BAR.BLOOD_PRESSURE':
                return {
                    component: <EPDeviceControl setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_BLOODPRESSURE"),
                    i18nSearchResults: t("GLOBAL.SEARCH_RESULTS") + " " + returnSearchResults + " " + t("GLOBAL.BED")
                }
            case 'NAV_BAR.BEDSTEAD':
                return {
                    component: <BedsteadManagement setReturnData={setReturnSearchResults} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_BEDSTEADS"),
                    i18nSearchResults: t("GLOBAL.SEARCH_RESULTS") + " " + returnSearchResults + " " + t("GLOBAL.BED")
                }
            case 'NAV_BAR.PADS':
                return {
                    component: <Pad setReturnData={setReturnSearchResults} institution={returnInst} mos={mos} />,
                    addPageBtn: true,
                    addPageName: t("GLOBAL.ADD_PADS"),
                    i18nSearchResults: t("GLOBAL.SEARCH_RESULTS") + " " + returnSearchResults + " " + t("GLOBAL.BED")
                }
            default:
                return {
                    component: <Dashboard mos={mos} />,
                    addPageBtn: false,
                    addPageName: '',
                    i18nSearchResults: ''
                }
        }
    }

    return (
        <div className="layout fx-d-c fx-nsbn">
            <AddPopUp />
            {(exportStart) ? residentExport.map((res, index) => <PrintPage data={res} key={index} />) : null}
            <CTXHide.Provider value={toggleAddPage}>
                {addPage ? <AddPageFrame /> : null}
            </CTXHide.Provider>
            {downloadHis ? <DownloadHis hide={toggleDownloadHis} /> : null}
            {ConfigHandler.isShowEP() && sortPage ? <DashboardSorting hide={toggleSortPage} /> : null}
            <div className="pad-45 l r w-100 h-100">
                <div className='w-100'>
                    {/* NavBar + 空白 */}
                    <NavBar mos={mos} />
                    <div className="pre_empty fx-d-c fx-fefs">
                        {LayoutPage.currentPage !== 0 ? <div className='w-100 fx-d-r fx-cspbt'>
                            <div className='w-50 fx-d-r'>
                                <div className='tag add fx-d-r font-ml fx-csbc' onClick={toggleAddPage}>{pageHandler().addPageName}</div>
                                {LayoutPage.currentPage === 1 ? <>
                                    <div className='tag leave_hos fx-d-r fx-cspar font-ml' onClick={toggleLeave}>
                                        <div className={`fx-ccc context ${i18n.language === 'en' ? 'font-m' : ""}`}>{leave ? t("RESIDENTS.LEAVE_HOS_LIST") : t("RESIDENTS.HOSPITALIZED")}</div>
                                        <div className={`btn_switch_RES beige ${leave ? "on_Click" : ''}`}></div>
                                    </div>
                                    {/* <div className='tag leave_hos fx-d-r fx-cspar font-ml' onClick={toggleDownloadHis}>
                                    <div className={`fx-ccc context dl_btm ${i18n.language==='en'? 'font-m':""}`}>下載報表</div>
                                    <div className=''></div>
                                </div> */}
                                </>
                                    : LayoutPage.currentPage === 2 ?
                                        <>
                                            <div className='tag dropDownIns fx-d-r fx-cspar font-ml' style={{ maxWidth: '280px' }} onClick={toggleDropdown}>
                                                <div className='w-30 drop-pad fx-ccc'>{t("GLOBAL.INSTITUTION_UNIT")}</div>
                                                <div className='drop-background w-70 h-auto' style={{ minWidth: 0 }}>
                                                    <Dropdown
                                                        index={'0'}
                                                        data={DP_data}
                                                        layout={true}
                                                        toggleDropdown={toggleDropdown}
                                                        closeToggle={dropdown_open}
                                                        selected={returnInst}
                                                        returnData={setReturnInst} />
                                                </div>
                                            </div>
                                        </> : null
                                }
                            </div>
                            <div className='w-30 fx-d-r fx-fec'>
                                <div className='tag search fx-cspar font-ml'>
                                    <div className='refreshFrame bgShadow' title='重新整理'>
                                        <div className='layoutRefresh clickRotate fx-d-r' onClick={() => { setRefresh(true) }}>
                                            <div className="reloadSingle"></div>
                                        </div>
                                    </div>
                                    <div className="cursor-def">{pageHandler().i18nSearchResults}</div>
                                </div>
                                <InfoMenu showInfoMenu={showInfoMenu} setShowInfoMenu={setShowInfoMenu}
                                    t={t} i18n={i18n} />
                            </div>
                        </div>
                            : ConfigHandler.isShowEP() ?
                                <div className='w-100 fx-d-r fx-csbc'>
                                    <div className='tag sorting fx-d-r font-ml fx-csbc' onClick={toggleSortPage}>
                                        <div className='w-60 fx-ccc'>{pageHandler().addPageName}</div>
                                        <div className='sortingIcon fx-d-r h-100 fx-ccc'>
                                            <div><div></div><div></div><div></div></div>
                                        </div>
                                    </div>
                                </div>
                                : <div className='w-100 fx-d-r fx-cspbt'>
                                    <div className='w-50 fx-d-r'>
                                        <div className='tag leave_hos fx-d-r fx-cspar font-ml' onClick={toggleSortDesc}>
                                            <div className='fx-ccc context'>{sortDesc ? t("GLOBAL.SORT_DESC") : t("GLOBAL.SORT_ASC")}</div>
                                            <div className={`btn_switch_RES beige ${sortDesc ? "on_Click" : ''}`}></div>
                                        </div>
                                    </div>
                                    <div className='w-30 fx-d-r fx-fec'>
                                        <InfoMenu showInfoMenu={showInfoMenu} setShowInfoMenu={setShowInfoMenu}
                                            t={t} i18n={i18n} />
                                    </div>
                                </div>
                        }
                    </div>
                </div>
                <div className={`page-frame footerDisable`}>
                    {pageHandler().component}
                </div>
                <p className="footer">Copyright 2026 © MWG. All rights reserved.</p>
            </div>
            {/* <div className="fx-ccc pad-15 b font-ml">{markC} {year} {t("GLOBAL.BRAND")}</div> */}
        </div>
    );

}
export default Layout;